 <template>

   <!--意见反馈弹窗-->
   <div class="alert-box">
     <p class="mask" @click="closeFun()"></p>
     <div class="alert-box-form border-box" :class="otaStatus">
       <img class="bottom-close" src="../assets/red-envelopes-close.png" @click="closeFun()" />
       <img class="icon_ota" src="../assets/ota-icon.png" />
       <span class="icon_line"></span>
        <div class="tit" v-if="type==0">门票激活失败</div>
        <div class="tit" v-if="type==1">门票激活成功</div>
        <div class="tit" v-if="type==2">门票激活码</div>
        <div class="sub_tit" v-if="type==0 || type==2">门票激活码只能激活一张解说专辑</div>
        <div class="sub_tit" v-if="type==1">您已成功使用门票激活该语音专辑</div>
       <div class="inp_box">
         <img class="ota_icon1" :class="type==0||type==1?'none':''" src="../assets/ota_icon1.png" alt="">
         <input type="number" maxlength="8"  placeholder="请输入购买门票获得的激活码" value="" v-model='code'>
         <div class="fail_text" v-if="type==0">请确认您输入的码是否正确</div>
       </div>
       <p class="ota_btn" v-if="type==0">重新激活</p>
       <p class="ota_btn" v-if="type==1" @click="closeFun()">知道了</p>
       <p class="ota_btn" v-if="type==2" @click="activeATO()">立即激活</p>
     </div>
   </div>

</template>

<script>

  import {activeOTAcode} from "@/service/getData";
  import {setStore, getStore, removeStore} from '@/config/mUtils'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
        return{
          userInfo: {},
          type:2,//OTA状态：0：失败 1：成功 2：正常
          otaStatus:'',//OTA状态类名
          code: ''
        }
    },
    created(){
      this.code = this.OTAcode
    },
    mounted(){

    },
    props: ['bagInfo','OTAcode'],
    computed: {

    },
    methods: {
      closeFun:function(){
        this.$emit('close',{close: 0, isbuy: false});
      },

      async activeATO(){
        this.userInfo = getStore("userInfo");
        if(this.code=='' || this.code==null || this.code==undefined){
          this.$toast('请输入门票获得的激活码');
          return
        }

        let res = await activeOTAcode({
          openid: this.userInfo.openid,
          pid: this.bagInfo.id,
          code: this.code
        });
        if (res.errcode == '00000') {
          this.$toast('激活成功')
          this.code = ''
          this.type= 1
          this.otaStatus = 'success'
          this.$emit('close',{close: 0, isbuy: true});
        }else {
          this.$toast(res.errmsg)
        }
      },


    }
}
</script>

<style scoped>

  @import '../style/alert';
  .alert-box-form{width: 78%;height:4.5rem;padding: .33rem .5rem 0;}
  .icon_ota{position: absolute;top: .24rem;right: .24rem;width:.32rem;height: auto; }
  .icon_line{position: absolute;top:50%;left:-.02rem;width: .1rem;height: 1.1rem;margin-top: -.55rem;background: #ff9c00;}
  .fail .icon_line{background: #c04908;}
  .success .icon_line{background: #68aa00;}
  .tit{font-size: .32rem;color: #584f61;font-weight: bold;}
  .fail .tit{color:#c04908;}
  .success .tit{color:#68aa00;}
  .sub_tit{margin-top:.22rem;font-size: .24rem;color: #999;}
  .inp_box{position:relative;width:96%;height:.51rem;line-height:.5rem;margin-top: .74rem;margin-left:2%;border-bottom: .01rem solid #e1e1e1;text-align: center;}
  .inp_box input{width: 100%;height: .50rem;line-height: .50rem;font-size: .24rem;color: #333;padding:0;margin:0;border:none;text-align: center;}
  .fail_text{position: absolute;left: 0;top:.58rem;width: 100%;font-size: .18rem;color: #c04908;text-align: center;}
  .ota_icon1{position: absolute;top:50%;left:.3rem;width: .28rem;height: auto;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .ota_btn{display: block;width: 2.8rem;height: .76rem;line-height: .76rem;margin:.78rem auto;font-size: .24rem;color: #fff;background: #ffb203;border-radius: .2rem;text-align: center;}
</style>



// WEBPACK FOOTER //
// src/components/AlertOTA.vue